<template>
    <div id="contactUs" class="contactUs-padding">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-7">
                <div class="breadcrumbs">
                    <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
                    <ul>
                        <li>
                            <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
                        </li>
                        <li>
                            <font-awesome-icon icon="arrow-right" class="right-agap"/>
                            <span>{{ $t('message.accessibility-statement') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <Language></Language>
        </div>
        <div class="row">
            <div class="col-12">
                <h1>
                    <span>{{ $t('message.accessibility-statement') }}</span>
                </h1>
                <div class="clearfix"></div>
                <div class="home-info">
                    <p v-if="selectedLanguageCode===`nn`"><a href="https://uustatus.no/nn/erklaringer/publisert/e3cbca41-3dc0-4296-8b45-7116005ac1a3">{{ $t('message.accessibility-link') }}</a></p>
                    <p v-else><a href="https://uustatus.no/nb/erklaringer/publisert/e3cbca41-3dc0-4296-8b45-7116005ac1a3">{{ $t('message.accessibility-link') }}</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Language from "./Language.vue";
export default {
    name: "AccessibilityStatementComponent",
    data() {
        return {
            languageCodeList:[
                {lang:'eng',langISOCode:'en'},
                {lang:'nny',langISOCode:'nn'},
                {lang:'nbo',langISOCode:'nb'}
            ]
        }
    },
    computed: {
        selectedLanguageCode () {
            return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
        },
    },
    components: {
        Language
    },
    created() {
        $("body,html").animate(
            {
                scrollTop: 0
            },
            60
        );
    }
};
</script>


